module.exports = __webpack_public_path__ + "static/media/webdesign-services-img50.e46bd694.jpg";